import Payment from "./PaymentUzairAccount";
const ServerHostingPage = () => {
  const handleWhatsAppClick = (packageName) => {
    const message = encodeURIComponent(
      `Hi! I'm interested in the ${packageName} package. Could you please provide more details?`,
    );
    const phoneNumber = "+923124998010"; // Replace with actual WhatsApp number
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, "_blank");
  };

  const packages = [
    {
      name: "Standard",
      price: "7,000 PKR",
      period: "/month",
      features: [
        "2 CPU Cores",
        "4GB RAM",
        "50GB SSD Storage",
        "1TB Bandwidth",
        "99.9% Uptime",
        "24/7 Basic Support",
        "Free SSL Certificate",
        "Daily Backups",
      ],
      popular: false,
      color: "primary",
    },
    {
      name: "Popular",
      price: "10500 PKR",
      period: "/month",
      features: [
        "4 CPU Cores",
        "8GB RAM",
        "100GB SSD Storage",
        "2TB Bandwidth",
        "99.99% Uptime",
        "24/7 Priority Support",
        "Free SSL Certificate",
        "Hourly Backups",
        "DDoS Protection",
        "Control Panel Access",
      ],
      popular: true,
      color: "success",
    },
    {
      name: "Pro",
      price: "19,000 PKR",
      period: "/month",
      features: [
        "8 CPU Cores",
        "16GB RAM",
        "250GB SSD Storage",
        "5TB Bandwidth",
        "99.99% Uptime",
        "24/7 Dedicated Support",
        "Free SSL Certificate",
        "Real-time Backups",
        "Advanced DDoS Protection",
        "Full Root Access",
        "Load Balancer",
        "Custom Firewall",
      ],
      popular: false,
      color: "warning",
    },
    {
      name: "One-Time Setup",
      price: "50,000 PKR",
      period: "One Time",
      features: [
        "Custom Deployment",
        "Initial Setup & Configuration",
        "Optimized Security Setup",
        "Domain & SSL Integration",
        "One-time Payment",
        "No Recurring Charges",
        "Basic Training Included",
      ],
      popular: false,
      color: "secondary",
    },
  ];

  return (
    <div
      style={{ fontFamily: "Arial, sans-serif", backgroundColor: "#f8f9fa" }}
    >
      {/* Header */}
      <header
        style={{
          backgroundColor: "#2c3e50",
          color: "white",
          padding: "60px 0",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h1
                style={{
                  fontSize: "3rem",
                  fontWeight: "bold",
                  marginBottom: "20px",
                }}
              >
                CloudHost Pro
              </h1>
              <p style={{ fontSize: "1.2rem", opacity: 0.9 }}>
                Premium Server Hosting Solutions for Your Business
              </p>
            </div>
          </div>
        </div>
      </header>

      {/* Pricing Section */}
      <section style={{ padding: "80px 0" }}>
        <div className="container">
          <div className="row">
            <div className="col-12 text-center mb-5">
              <h2
                style={{
                  fontSize: "2.5rem",
                  fontWeight: "bold",
                  color: "#2c3e50",
                  marginBottom: "20px",
                }}
              >
                Choose Your Perfect Plan
              </h2>
              <p
                style={{
                  fontSize: "1.1rem",
                  color: "#6c757d",
                  maxWidth: "600px",
                  margin: "0 auto",
                }}
              >
                Select from our range of high-performance server hosting
                packages designed to meet your specific needs
              </p>
            </div>
          </div>

          <div className="row justify-content-center">
            {packages.map((pkg, index) => (
              <div key={index} className="col-lg-4 col-md-6 mb-4">
                <div
                  className={`card h-100 ${
                    pkg.popular ? "border-success" : ""
                  }`}
                  style={{
                    boxShadow: pkg.popular
                      ? "0 10px 30px rgba(0,0,0,0.2)"
                      : "0 5px 15px rgba(0,0,0,0.1)",
                    border: pkg.popular
                      ? "3px solid #28a745"
                      : "1px solid #dee2e6",
                    transform: pkg.popular ? "scale(1.05)" : "scale(1)",
                    transition: "all 0.3s ease",
                  }}
                >
                  {pkg.popular && (
                    <div
                      style={{
                        backgroundColor: "#28a745",
                        color: "white",
                        textAlign: "center",
                        padding: "10px",
                        fontWeight: "bold",
                        fontSize: "0.9rem",
                      }}
                    >
                      MOST POPULAR
                    </div>
                  )}

                  <div className="card-body d-flex flex-column">
                    <div className="text-center mb-4">
                      <h3
                        style={{
                          fontSize: "1.8rem",
                          fontWeight: "bold",
                          color: "#2c3e50",
                        }}
                      >
                        {pkg.name}
                      </h3>
                      <div style={{ margin: "20px 0" }}>
                        <span
                          style={{
                            fontSize: "3rem",
                            fontWeight: "bold",
                            color: "#e74c3c",
                          }}
                        >
                          {pkg.price}
                        </span>
                        <span style={{ fontSize: "1.1rem", color: "#6c757d" }}>
                          {pkg.period}
                        </span>
                      </div>
                    </div>

                    <ul className="list-unstyled flex-grow-1">
                      {pkg.features.map((feature, idx) => (
                        <li
                          key={idx}
                          style={{
                            padding: "8px 0",
                            borderBottom: "1px solid #f8f9fa",
                          }}
                        >
                          <span
                            style={{ color: "#28a745", marginRight: "10px" }}
                          >
                            ✓
                          </span>
                          {feature}
                        </li>
                      ))}
                    </ul>

                    <button
                      className={`btn btn-${pkg.color} btn-lg w-100 mt-3`}
                      onClick={() => handleWhatsAppClick(pkg.name)}
                      style={{
                        fontWeight: "bold",
                        padding: "12px",
                        fontSize: "1.1rem",
                        transition: "all 0.3s ease",
                      }}
                      onMouseOver={(e) =>
                        (e.target.style.transform = "translateY(-2px)")
                      }
                      onMouseOut={(e) =>
                        (e.target.style.transform = "translateY(0)")
                      }
                    >
                      Get Started via WhatsApp
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section style={{ backgroundColor: "white", padding: "80px 0" }}>
        <div className="container">
          <div className="row">
            <div className="col-12 text-center mb-5">
              <h2
                style={{
                  fontSize: "2.5rem",
                  fontWeight: "bold",
                  color: "#2c3e50",
                  marginBottom: "20px",
                }}
              >
                Why Choose CloudHost Pro?
              </h2>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4 text-center mb-4">
              <div
                style={{
                  backgroundColor: "#3498db",
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 20px",
                  color: "white",
                  fontSize: "2rem",
                }}
              >
                🚀
              </div>
              <h4 style={{ color: "#2c3e50", marginBottom: "15px" }}>
                High Performance
              </h4>
              <p style={{ color: "#6c757d" }}>
                Lightning-fast SSD storage and optimized server configurations
                for maximum performance.
              </p>
            </div>

            <div className="col-md-4 text-center mb-4">
              <div
                style={{
                  backgroundColor: "#2ecc71",
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 20px",
                  color: "white",
                  fontSize: "2rem",
                }}
              >
                🔒
              </div>
              <h4 style={{ color: "#2c3e50", marginBottom: "15px" }}>
                Secure & Reliable
              </h4>
              <p style={{ color: "#6c757d" }}>
                Advanced security measures and 99.99% uptime guarantee to keep
                your applications running smoothly.
              </p>
            </div>

            <div className="col-md-4 text-center mb-4">
              <div
                style={{
                  backgroundColor: "#f39c12",
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 20px",
                  color: "white",
                  fontSize: "2rem",
                }}
              >
                💬
              </div>
              <h4 style={{ color: "#2c3e50", marginBottom: "15px" }}>
                24/7 Support
              </h4>
              <p style={{ color: "#6c757d" }}>
                Round-the-clock expert support team ready to help you with any
                technical issues.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Payment />

      <footer
        style={{
          backgroundColor: "#2c3e50",
          color: "white",
          padding: "40px 0",
          textAlign: "center",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h3 style={{ marginBottom: "20px" }}>CloudHost Pro</h3>
              <p style={{ opacity: 0.8, marginBottom: "20px" }}>
                Premium Server Hosting Solutions | Available 24/7 for Support
              </p>
              <button
                className="btn btn-success btn-lg"
                onClick={() => handleWhatsAppClick("General Inquiry")}
                style={{
                  fontWeight: "bold",
                  padding: "12px 30px",
                  fontSize: "1.1rem",
                }}
              >
                💬 Contact Us on WhatsApp
              </button>
              <div style={{ marginTop: "30px", opacity: 0.6 }}>
                <p>&copy; 2025 CloudHost Pro. All rights reserved.</p>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Bootstrap CSS */}
      <link
        href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.0/css/bootstrap.min.css"
        rel="stylesheet"
      />
    </div>
  );
};

export default ServerHostingPage;
